'use client';

import { Button } from '@get-mosh/msh-shared';
import { trackClick } from 'src/analytics/Events';
import EventNames from 'src/analytics/EventNames';
import { SliceComponentProps } from '@prismicio/react';
import { Content } from '@prismicio/client';
import { Vertical } from 'src/constants/Verticals';

type ButtonSliceProps = SliceComponentProps<Content.ButtonSlice> & {
    context: {
        pageType: string;
    };
};

const ButtonSlice = ({ slice, context }: ButtonSliceProps) => (
    <section className="mt-4 flex items-center justify-center px-4">
        <Button
            as="a"
            text={slice.primary.cta || 'Button'}
            href={slice.primary.path || '/'}
            onClick={() => {
                trackClick(EventNames.BUTTON_CLICKED, {
                    pageType: context.pageType,
                    vertical: slice.primary.vertical as Vertical,
                    label: slice.primary.cta || 'Button',
                    link: slice.primary.path || '/',
                    variation: slice.variation,
                    location: slice.slice_type,
                });
            }}
        />
    </section>
);

export default ButtonSlice;
